import { ComponentType } from 'react';
import { Route, Redirect, RouteProps } from 'react-router-dom';
import { useAuth } from './auth/AuthProvider';

export interface PublicRouteProps {
  component: ComponentType<any>;
  path: string;
}

const PublicRoute = ({ component: Component, path }: PublicRouteProps) => {
  const { isAuthenticated } = useAuth();

  return (
    <Route
      path={path}
      render={(props: RouteProps) =>
        !isAuthenticated ? (
          <Component {...props} />
        ) : (
          <Redirect to="/panels" />
        )
      }
    />
  );
};

export default PublicRoute;